module.exports = __webpack_public_path__ + "static/media/logo.24e8a9ce.png";